// @ts-nocheck
import SecureStorage from "secure-web-storage";
import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_STORAGE_SECRET_KEY;

const secureConfig = {
	hash: function hash(key) {
		key = CryptoJS.SHA256(key, SECRET_KEY);
		return key.toString();
	},
	encrypt: function encrypt(data) {
		data = CryptoJS.AES.encrypt(data, SECRET_KEY);
		data = data.toString();
		return data;
	},
	decrypt: function decrypt(data) {
		data = CryptoJS.AES.decrypt(data, SECRET_KEY);
		data = data.toString(CryptoJS.enc.Utf8);
		return data;
	},
};

const instances = new Map();

function getStorage(store) {
	if (instances.has(store)) return instances.get(store);
	const secStorage = new SecureStorage(store, secureConfig);
	const instance = {
		getItem: (key) => {
			try {
				return secStorage.getItem(key);
			} catch (e) {
				return null;
			}
		},
		setItem: (key, data) => secStorage.setItem(key, data),
		removeItem: (key) => secStorage.removeItem(key),
	};
	instances.set(store, instance);
	return instance;
}

class Storage {
	#instance = null;
	constructor(secret_key, forceReload, storage) {
		this.forceReload = forceReload;
		let store = storage ? storage : localStorage;
		this.#instance = getStorage(store);
	}

	getItem = (key) => this.#instance.getItem(key);
	setItem = (key, data) => this.#instance.setItem(key, data);
	removeItem = (key) => this.#instance.removeItem(key);
}

export default Storage;
